export enum LoginResult {

    /** Zadané přihlašovací údaje jsou v pořádku */
    ok,

    /** Uživatel nebyl nalezen (špatné uživatelské jméno nebo heslo) */
    userNotFound,

    /** Doména není mezi povolenými */
    invalidDomain,

    /** Uživatelský účet není aktivován (disabled) */
    accountNotActivated,

    /** Uživatelské heslo expirovalo */
    passwordExpired,

    /** Uživatel musí provést změnu hesla */
    userMustChangePassword,

    /** Účet je uzamčen */
    accountLocked,

    /** Účet expiroval */
    accountExpired,

    /** Byl překročen limit pro neúspěšný počet přihlašovacích pokusů */
    logonLimitExceeded,

    /** Uživatel nemá povolený přístup do daného systému */
    accessDenied,

    /**
     * Přihlašovací údaje jsou v pořádku.
     * Vyžaduje přihlášení pomocí klíče OTP, který je poslán uživateli jako SMS,
     * protože je aktivní dvoufaktorová autentizace typu OTP.
     */
    OTPSmsRequired,

    /** Přihlašovací údaje jsou v pořádku.
     * Vyžaduje přihlášení pomocí klíče OTP, který je odeslán uživateli na email,
     * protože je aktivní dvoufaktorová autentizace typu OTP.
     */
    OTPEmailRequired,

    /** Přihlašovací údaje jsou v pořádku.
     * Vyžaduje TOTP autentizaci,
     * protože je aktivní dvoufaktorová autentizace typu TOTP.
     */
    TOTPRequired,

    /** Klíč druhého stupně dvoufaktorové autentizace nesouhlasí. */
    invalid2FAKey,

    /** Platnost klíče druhého stupně dvoufaktorové autentizace vypršela. */
    keyExpired,

    /** Klíč byl zadán vícekrát než je dovoleno za určitou jednotku času. */
    keyLimitExceeded,

    /** Neexistující záznam v databázi. */
    dbError,

    /** Token není platný. */
    invalidToken,
}
